/**
 * This is a random uid generator similar to the one used in
 * RC-Upload component which Ant uses internally for its file upload.
 */

export const uid = (prefix = 'uid'): string => {
  const now = +new Date();

  return [prefix, now].join('-');
};

export const floatUid = (): number => Math.floor(Math.random() * Date.now());

export const negativeUid = (): number => -1 * floatUid();
